if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"gale","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(2(091|246|469|636|878)|3(063|388|714)|5(041|170|99)|7(9(30|42|63)|024)|8(056|090|167|331|720|807)|9(3(09|44|68)|085|121|250|45|614)|1468|1674|4098)$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}